// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1UsVd","label":"Section_label__2OdDI","contentWrap":"Section_contentWrap__3hwXo","footer":"Section_footer__1k7nk","footerInner":"Section_footerInner__1I4ks"};